import React from 'react';
import Anime from 'react-anime';
import './GiantCircle.scss';
export default ({ isActive }) => {
  const dropAndGrow = {
    opacity: [
      { value: 0, duration: 0 },
      { value: 1, duration: 500, easing: 'linear'}
    ],
    translateY: [
      { value: '-50vh', duration: 0 },
      { value: '-5vh', duration: 1000, easing: 'easeOutQuad'}
    ],
    scale: [
      { value: 0.1, duration: 0},
      { value: 1, duration: 1000, easing: 'linear'}
    ]
  }
  const fadeInTitle = {
    opacity: [
      { value: 0, duration: 0, delay: 500},
      { value: 1, duration: 500, easing: 'linear' }
    ]
  }
  const dropAndMove = {
    translateY: [
      { value: '5vh', duration: 0, easing: 'easeOutQuad' }
    ],
    translateX: [
      { value: '33%', duration: 0, easing: 'easeOutQuad'}
    ],
    scale: [
      { value: 0, duration: 0, easing: 'easeOutQuad', delay: 750 },
      { value: 1.5, duration: 2000, easing: 'easeOutQuad' }
    ]
  }

  return (
    <div className="giant-circle-container">
      {isActive && (
      <Anime className="pipe">
        <div className="pipe-body"></div>
      </Anime>
      )}
      {isActive && (
        <Anime {...dropAndMove} className="hide-desktop image-ball">
          <div></div>
        </Anime>
      )}
      <div className="flex-container">
        {isActive && (
          <div className="giant-circle">
            <Anime {...dropAndGrow}>
              <Anime {...fadeInTitle}>
                <div className="inner-circle">
                  <span>800m</span>
                  <p className="sub-heading">800 million people use a medicine developed by Novartis.</p>
                </div>
              </Anime>
            </Anime>
          </div>
        )}
        {isActive && (
          <Anime {...fadeInTitle} className="title-section">
            <p className="secondary-large centered landscape-shrink">Each of these treatments underwent a series of clinical investigations that followed a rigorous scientific protocol to test for safety and efficacy. </p>
          </Anime>
        )}
      </div>
    </div>
  );
};